import slugify from "@sindresorhus/slugify";
import clsx from "clsx";

import { ICommentDTO } from "types";
export { clsx as cx, slugify };

export function calculateTotalCommentsSize(comments: ICommentDTO[]): number {
    let totalSize = 0;
    for (const comment of comments) {
        totalSize += 1; // Count the current comment
        if (comment.replies && comment.replies.length > 0) {
            // Recursively count replies
            totalSize += calculateTotalCommentsSize(comment.replies);
        }
    }
    return totalSize;
}
